import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomFooter from "../commoncomponents/CustomFooter";
import { useNavigate, useLocation } from "react-router";
import axios from "axios";
import {
  getAuthToken,
  getFacilityId,
  getModifiedBy,
  getuserId,
} from "../../utility/tokenUtility";
import CustomDialog from "../commoncomponents/CustomDialog";
import { MasterGraph } from "../../utility/apiURLS";
import { dialogContent } from "../../utility/message";
import PageTitle from "../commoncomponents/PageTitle";

const CreateUserDepartment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [deptCode, setDeptCode] = useState("");
  const [deptDesc, setDeptDesc] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [departmentId, setDepartmentId] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isAddingNew, setIsAddingNew] = useState(false); // New state for tracking Add New action
  const deptCodeRef = useRef(null);
  const deptDescRef = useRef(null);

  useEffect(() => {
    if (isEdit) {
      deptDescRef.current.focus();
    } else {
      deptCodeRef.current.focus();
    }
  }, [isEdit]);

  const [errors, setErrors] = useState({
    deptCode: false,
    deptDesc: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    deptCode: "",
    deptDesc: "",
  });
  const modifiedBy = getModifiedBy("modifiedBy");

  useEffect(() => {
    if (location.state) {
      const { departmentcode, departmentdesc, id, readOnly } = location.state;
      setDeptCode(departmentcode);
      setDeptDesc(departmentdesc);
      setDepartmentId(id);
      setReadOnly(readOnly || false);
      setIsEditMode(!readOnly);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [location.state]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let formIsValid = true;
    const newErrors = { deptCode: false, deptDesc: false };
    const newErrorMessages = { deptCode: "", deptDesc: "" };
    if (!deptCode) {
      formIsValid = false;
      newErrors.deptCode = true;
      newErrorMessages.deptCode = "Department Code is required";
    } else if (deptCode.trim() !== deptCode) {
      // Check if there are leading spaces
      formIsValid = false;
      newErrors.deptCode = true;
      newErrorMessages.deptCode =
        "Invalid Input: Only alphanumeric characters, /, -, and spaces are allowed.";
    } else if (!/^[a-zA-Z0-9\/ -]+$/.test(deptCode)) {
      // Check for invalid characters
      formIsValid = false;
      newErrors.deptCode = true;
      newErrorMessages.deptCode =
        "Invalid Input: Only alphanumeric characters, /, -, and spaces are allowed.";
    } else {
      // Clear errors if input is valid
      newErrors.deptCode = false;
      newErrorMessages.deptCode = "";
    }
    if (!deptDesc) {
      formIsValid = false;
      newErrors.deptDesc = true;
      newErrorMessages.deptDesc = "Department Description is required";
    } else if (deptDesc.startsWith(" ")) {
      formIsValid = false;
      newErrors.deptDesc = true;
      newErrorMessages.deptDesc =
        "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed";
    } else if (/  /.test(deptDesc)) {
      formIsValid = false;
      newErrors.deptDesc = true;
      newErrorMessages.deptDesc =
        "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed";
    } else if (/[^a-zA-Z0-9 ,!@#$%&*()_-]/.test(deptDesc)) {
      formIsValid = false;
      newErrors.deptDesc = true;
      newErrorMessages.deptDesc =
        "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed";
    }
    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    if (formIsValid) {
      handleSave();
    }
  };

  const handleSave = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      setUnsavedChanges(false);

      let endpoint = `${MasterGraph}/api/masuserdepartmentdetails`;
      let method = "post";

      if (isEditMode) {
        endpoint = `${MasterGraph}/api/masuserdepartmentdetails/${departmentId}`;
        method = "put";
      }

      const postData = {
        departmentcode: deptCode,
        departmentdesc: deptDesc,
        id: departmentId,
        isdelete: false,
        facilityid: getFacilityId("facilityId"),
        createdby: getuserId("UserId"),
      };

      await axios({
        method: method,
        url: endpoint,
        data: postData,
        headers: config.headers,
      });
      setDialogOpen(true);
    } catch (error) {
      //  console.error("Error deleting user department:", error);
      if (error.response && error.response.status === 400) {
        // Assuming 409 is the status code for "Conflict"
        setErrorMessage(" Department Code  is already exists ");
      } else {
        setErrorMessage(
          "An error occurred while Save the user department. Please try again."
        );
      }
    }
  };

  const handleDeptCodeChange = (newValue) => {
    setUnsavedChanges(true);
    setDeptCode(newValue);

    if (newValue.startsWith(" ")) {
      setErrors((prevErrors) => ({ ...prevErrors, deptCode: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptCode: "Invalid Input / and - Only these two special characters are allowed",
      }));
    } else if (/[^a-zA-Z0-9\/ -]/.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, deptCode: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptCode: "Invalid input. Only letters, numbers, /, and - are allowed.",
      }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptCode: "Invalid Input / and - Only these two special characters are allowed",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, deptCode: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, deptCode: "" }));
    }
  };

  const handleDeptDescChange = (newValue) => {
    setUnsavedChanges(true);
    setDeptDesc(newValue);

    if (newValue.startsWith(" ")) {
      setErrors((prevErrors) => ({ ...prevErrors, deptDesc: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptDesc: "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed",
      }));
    } else if (newValue.includes("  ")) {
      setErrors((prevErrors) => ({ ...prevErrors, deptDesc: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptDesc: "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed",
      }));
    } else if (/[^a-zA-Z0-9 ,!@#$%&*()_-]/.test(newValue)) {
      setErrors((prevErrors) => ({ ...prevErrors, deptDesc: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        deptDesc:
          "Invalid Input a-zA-Z0-9,-_!@#$%&*() - Only these characters are allowed",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, deptDesc: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, deptDesc: "" }));
    }
  };

  const handleCancel = () => {
    if (unsavedChanges) {
      setIsAddingNew(false); // Reset the state
      setCancelDialogOpen(true);
    } else {
      navigate(-1, { replace: true });
    }
  };

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleConfirmCancel = () => {
    setCancelDialogOpen(false);
    setUnsavedChanges(false); // Reset unsaved changes state
    if (isAddingNew) {
      setDeptCode("");
      setDeptDesc("");
      setErrors(false);
      setErrorMessages("");
    } else {
      navigate(-1, { replace: true });
    }
  };

  const handleAddNew = () => {
    if (unsavedChanges) {
      setIsAddingNew(true); // Set the state to indicate Add New action
      setCancelDialogOpen(true);
    } else {
      setDeptCode("");
      setDeptDesc("");
      setErrors(false);
      setErrorMessages("");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    // navigate(-1, { replace: true });
  };

  return (
    <>
      <PageTitle
        title="Create User Department"
        editTitle={"Edit User Department"}
        isEdit={isEdit}
      />
      <Box mt={{ xs: 1, md: 2 }}>
        <DefaultCard sx={{ height: "100%" }}>
          <form onSubmit={handleSubmit} style={{ position: "relative" }}>
            <Box mb={2}>
              <Grid container spacing={4}>
                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={10}
                    label="Department Code"
                    id="department-code"
                    value={deptCode}
                    onChange={handleDeptCodeChange}
                    inputRef={deptCodeRef}
                    isMandatoryField={true}
                    error={errors.deptCode}
                    disabled={isView || isEditMode ? true : false}
                    errorMessage={errorMessages.deptCode}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <CustomTextField
                    maxlength={255}
                    label="Department Description"
                    id="department-description"
                    value={deptDesc}
                    onChange={handleDeptDescChange}
                    disabled={readOnly}
                    autoFocus={isEdit ? true : false}
                    isMandatoryField={true}
                    error={errors.deptDesc}
                    errorMessage={errorMessages.deptDesc}
                    inputRef={deptDescRef}
                  />
                </Grid>
              </Grid>
            </Box>
          </form>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <CustomFooter
              cancelClick={handleCancel}
              saveClick={handleSubmit}
              addClick={handleAddNew}
              readOnly={readOnly}
              buttonLabel={isEdit ? "Update" : "Save"}
              isEdit={isEdit}
              showAddButton={true}
            />
          </Box>
        </DefaultCard>
      </Box>
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogClose}
        confirmBtn={"Ok"}
        content={
          isEdit ? <>{dialogContent.updated}</> : <>{dialogContent.saved}</>
        }
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning!"
        content={errorMessage}
        confirmBtn={"Ok"}
      />
      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        onConfirm={handleConfirmCancel}
        content={dialogContent.modified}
        cancelBtn="No"
        confirmBtn="Yes"
      />
    </>
  );
};

export default CreateUserDepartment;
